import {Play,EventParam} from './Inc';
export class Tools {
    static getWindowSize = ()=>{
        let wd = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        w = wd.innerWidth || e.clientWidth || g.clientWidth,
        h = wd.innerHeight|| e.clientHeight|| g.clientHeight;
    
        return {
            width: w,
            height: h
        }
    }
    static isWidthDown = (num:number)=>{
        const size = Tools.getWindowSize();
        if( size.width<num ){
            return true;
        }
        return false;
    }
    static getModalStyle = ()=> {
        const top = 50;
        const left = 50;
      
        return {
            top: `${top}%`,
            left: `${left}%`,
            transform: `translate(-${top}%, -${left}%)`,
        };
    }
    static getModalSearchStyle = ()=>{
        const size = Tools.getWindowSize();
        let w = 800;
        if( size.width<800 ){
            w = size.width;
        }
        let h = size.height*0.8;
        if( h>800 ){
            h = 800;
        }
        return {
            width: `${w}px`,
            height: `${h}px`,
            backgroundColor: `white`,
        };
    }
    static decodeQueryStrings(str:string){
        const sp1 = str.replace("?","").split("&");
        let data:{[key: string]: string;} = {};
        for(let i=0 ; i<sp1.length ; i++){
            const sp2 = sp1[i].split("=");
            data[ sp2[0] ] = sp2[1];
        }
        return data;
    }
    static zeroPadding = (num:string,length:number)=>{
        return ('0000000000' + num).slice(-length);
    }
    static roomName = (floor:number,room:number)=>{
        if( room>8 ){
            room = room - 8;
        }
        return String(floor) + ("0"+String(room)).substr(-2,2);
    }
    static voice = ()=>{
        const v:string[] = ["へえ","そう","はいはい","うん","ふうん"];
        return v[ Math.floor(Math.random()*5) ];
    }
    static lover = (play:Play,param:EventParam)=>{
        if( play.lover_nick!=="" && param.called!==2 ){
            return play.lover_nick;
        }
        if( play.lover_name!=="" && param.called!==1 ){
            return play.lover_name;
        }
        return "誰か";
    }
    static rand = (num:number)=>{
        return Math.floor(Math.random()*num);
    }
}